/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { AiPromptBatchesWebhookControllerHandleOpenAIWebhookMutationResponse } from '../../types/AiPromptBatchesWebhookControllerHandleOpenAIWebhook.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { aiPromptBatchesWebhookHandleOpenAIWebhook } from '../../methods/aiPromptBatchesWebhookHandleOpenAIWebhook.ts';
import { useMutation } from '@tanstack/react-query';

export const aiPromptBatchesWebhookHandleOpenAIWebhookMutationKey = () =>
  [{ url: '/api/webhooks/openai/ai-prompt-batches' }] as const;

export type AiPromptBatchesWebhookHandleOpenAIWebhookMutationKey = ReturnType<
  typeof aiPromptBatchesWebhookHandleOpenAIWebhookMutationKey
>;

/**
 * {@link /api/webhooks/openai/ai-prompt-batches}
 */
export function useAiPromptBatchesWebhookHandleOpenAIWebhook<TContext>(
  options: {
    mutation?: UseMutationOptions<
      AiPromptBatchesWebhookControllerHandleOpenAIWebhookMutationResponse,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? aiPromptBatchesWebhookHandleOpenAIWebhookMutationKey();

  return useMutation<
    AiPromptBatchesWebhookControllerHandleOpenAIWebhookMutationResponse,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return aiPromptBatchesWebhookHandleOpenAIWebhook(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
